// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anek+Bangla:wght@100;200;300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

:root,
[data-bs-theme='light'] {
  --bs-blue: #0076ff;
  --bs-gray-dark: #343a40;
  --bs-gray-light: #a2a7c0;
  --bs-gray-ultra-light: #e6e6e6;
  --bs-gray-100: #e7e9f2;
  --bs-gray-200: #3f4872;
  --bs-gray-400: #7c84a5;
  --bs-primary: #0076ff;
  --bs-dark-blue: #000e4e;
  --bs-light-blue: #57608a;
  --bs-primary-rgb: 0, 118, 255;
  --bs-link-color: #0076ff;
  --bs-light-gray: #a2a7c0;
  --bs-success: #41a895;
  --bs-success-rgb: 65, 168, 149;
  --bs-danger: #eb0000;
  --bs-warning: #fccb4f;
}
*,
::after,
::before {
  font-family: 'Anek Bangla', sans-serif !important;
  box-sizing: border-box;
}
.h1,
h1 {
  font-size: 44px !important;
  font-weight: 600 !important;
  color: var(--bs-dark-blue) !important;
}

.h2,
h2 {
  font-size: 30px !important;
  font-weight: 600 !important;
  color: var(--bs-dark-blue) !important;
}

.h3,
h3 {
  font-size: 22px !important;
  font-weight: 600 !important;
  color: var(--bs-dark-blue) !important;
}

.h4,
h4 {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: var(--bs-dark-blue) !important;
}

.form-control {
  border: var(--bs-border-width) solid var(--bs-light-gray);
}
.form-check-input:checked {
  background-color: #0076ff;
  border-color: #0076ff;
}

.form-range::-webkit-slider-thumb {
  background-color: #0076ff;
}
.btn-primary {
  background: linear-gradient(288.08deg, #0076ff 0%, #0076ff 100%);
  --bs-btn-border-color: #0076ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0060ef;
  --bs-btn-hover-border-color: #0076ff;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0076ff;
  --bs-btn-disabled-border-color: #0076ff;
}

.btn-outline-primary {
  --bs-btn-color: #0076ff;
  --bs-btn-border-color: #0076ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0076ff;
  --bs-btn-hover-border-color: #0076ff;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0076ff;
  --bs-btn-active-border-color: #0076ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0076ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0076ff;
  --bs-gradient: none;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.375rem;
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(0.375rem - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(var(--bs-body-color-rgb), 0.15);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0076ff;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0076ff;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.375rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0076ff;
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0076ff;
  --bs-pagination-active-border-color: #0076ff;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0076ff;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0076ff;
  --bs-list-group-active-border-color: #0076ff;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.link-primary {
  color: #0076ff !important;
}

.shadow {
  box-shadow: 0px 10px 20px 5px rgb(var(--bs-primary-rgb), 0.1) !important;
}

.shadow::before {
  z-index: -1;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.text-dark-blue {
  --bs-text-opacity: 1;
  color: var(--bs-dark-blue) !important;
}

.text-gray-200 {
  --bs-text-opacity: 1;
  color: var(--bs-gray-200) !important;
}

.text-light-gray {
  --bs-text-opacity: 1;
  color: var(--bs-light-gray) !important;
}

.text-gray-400 {
  --bs-text-opacity: 1;
  color: var(--bs-gray-400) !important;
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
}

input {
  border-radius: 10px;
}

.login-divider {
  width: 50%;
  text-align: center;
  border-bottom: 1px solid var(--bs-light-gray);
  line-height: 0.1em;
  margin: auto;
}

.login-divider span {
  background: #fff;
  padding: 0 10px;
  color: var(--bs-light-gray);
}

.form-control::placeholder {
  color: var(--bs-light-gray) !important;
  opacity: 1;
}

.form-control,
.form-control .form-control-lg {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--bs-dark-blue) !important;
  opacity: 1; /* Firefox */
}

.form-control:focus {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--bs-dark-blue) !important;
  opacity: 1; /* Firefox */
}

/* CHOOSE REPORT  */
.lines-icon {
  top: 69.19px;
  left: 0;
  width: 1225.01px;
  height: 3px;
}
.div {
  position: relative;
  line-height: 120%;
  font-weight: 600;
}
.tick {
  top: 2px;
  left: 0;
  border-radius: 100px;
  background-color: #f8f9fd;
  border: 2px solid #0076ff;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
  justify-content: center;
  color: #0076ff;
}
.tick,
.tick1,
.tick2 {
  position: absolute;
}
.tick1 {
  top: 0;
  left: 260px;
  border-radius: 100px;
  background-color: #fff;
  border: 2px solid #c8ccdf;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
  justify-content: center;
}
.tick2 {
  top: 2px;
  left: 482px;
}
.tick2,
.tick3,
.tick4 {
  border-radius: 100px;
  background-color: #fff;
  border: 2px solid #c8ccdf;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
  justify-content: center;
}
.tick3 {
  position: absolute;
  top: 2px;
  left: 710px;
}
.tick4 {
  top: 3px;
  left: 938px;
}
.tick4,
.tick5,
.ticks {
  position: absolute;
}
.tick5 {
  top: 2px;
  left: 1216px;
  border-radius: 100px;
  background-color: #fff;
  border: 2px solid #c8ccdf;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
  justify-content: center;
}
.ticks {
  top: 57px;
  left: 0;
  width: 1240px;
  height: 27px;
}
.upload-credit-reports {
  position: relative;
  line-height: 120%;
  font-weight: 600;
  color: #0076ff;
  text-align: left;
  display: inline-block;
  width: 111px;
  flex-shrink: 0;
}
.choose-items {
  margin-block-start: 0;
  margin-block-end: 0;
}
.to-be-disputed {
  margin: 0;
}
.choose-items-to-container,
.confirm-personal-information-container,
.disputes-created {
  position: relative;
  line-height: 120%;
  display: inline-block;
  width: 111px;
  flex-shrink: 0;
}
.confirm-personal-information-container,
.disputes-created {
  width: 123px;
}
.disputes-created {
  text-align: right;
}
.steps {
  top: 0;
  left: 0;
  width: 1240px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #7c84a5;
  scrollbar-width: none;
}
.steps::-webkit-scrollbar{
  display: none;
}
.creating-status,
.heading {
  left: 100px;
}
.creating-status {
  top: 171px;
  width: 1240px;
  height: 84px;
  text-align: center;
  font-size: 12px;
  color: #c8ccdf;
}
.heading {
  top: 120px;
  font-size: 22px;
  line-height: 140%;
  font-weight: 600;
}
.heading1,
.supporting-text,
.supporting-text1 {
  position: relative;
  line-height: 140%;
  display: inline-block;
}
.heading1 {
  font-weight: 600;
  width: 103px;
}
.supporting-text,
.supporting-text1 {
  width: 604px;
}
.supporting-text {
  font-weight: 500;
}
.supporting-text1 {
  color: #7c84a5;
}
.heading-supporting-text,
.text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.text {
  justify-content: flex-start;
  font-size: 18px;
  color: #3f4872;
}
.heading-supporting-text {
  top: 335px;
  left: 100px;
  justify-content: center;
  font-size: 22px;
}

.ill-do-this,
.why-do-you {
  position: relative;
  line-height: 140%;
}
.why-do-you {
  display: inline-block;
  width: 387px;
  flex-shrink: 0;
}
.ill-do-this {
  font-weight: 500;
}
.button {
  height: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #0076ff;
}
.for-more-details {
  position: relative;
  line-height: 140%;
  display: inline-block;
  width: 121px;
  flex-shrink: 0;
}
.why-do-you-need-to-use-ai-comp-parent {
  top: 571px;
  left: 100px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
}
.icons {
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.tick6 {
  border-radius: 100px;
  background-color: #0076ff;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  color: white;
}
.text1 {
  flex: 1;
  position: relative;
  line-height: 160%;
}
.item,
.list-items {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.item {
  align-self: stretch;
  flex-direction: row;
  gap: 12px;
}
.list-items {
  top: 133px;
  left: 78px;
  width: 434px;
  flex-direction: column;
  gap: 18px;
}
.improve-letters-now {
  position: relative;
  line-height: 140%;
  font-weight: 600;
}
.button1 {
  border-radius: 10px;
  background: linear-gradient(-71.92deg, #0076ff, #0076ff);
  width: 434px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  padding: 16px 24px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
}
.button-icon {
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  overflow: hidden;
  display: none;
}
.content {
  flex-direction: row;
  justify-content: flex-start;
  gap: 12px;
}
.button2,
.buttons,
.content {
  display: flex;
  /* align-items: center; */
}
.button2 {
  border-radius: 10px;
  border: 1.5px solid #0076ff;
  box-sizing: border-box;
  width: 437px;
  height: 53px;
  flex-shrink: 0;
  flex-direction: row;
  padding: 12px 30px;
  justify-content: center;
  color: #0076ff;
}
.buttons {
  top: 619px;
  left: 78px;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  color: #fff;
}
.download-1-icon {
  align-self: stretch;
  flex: 1;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  object-fit: cover;
}
.logo-company {
  top: 50px;
  left: 150px;
  width: 290px;
  height: 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.smartcredit {
  top: 1493px;
  left: 100px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 6px 40px rgba(0, 118, 255, 0.1);
  width: 590px;
  height: 785px;
  overflow: hidden;
  font-size: 16px;
  color: #3f4872;
}
.list-items1,
.logo-company1 {
  display: flex;
  flex-direction: column;
}
.list-items1 {
  top: 127px;
  left: 78px;
  width: 434px;
  height: 446px;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 18px;
}
.logo-company1 {
  top: 50px;
  left: 207px;
  width: 177px;
  height: 47px;
  align-items: center;
  justify-content: center;
}
.truly-id {
  top: 1493px;
  left: 750px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 6px 40px rgba(0, 118, 255, 0.1);
  width: 590px;
  height: 785px;
  overflow: hidden;
  font-size: 16px;
  color: #3f4872;
}
.budge,
.item13 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.budge {
  border-radius: 10px;
  background: linear-gradient(-71.92deg, #0076ff, #0076ff);
  border: 3px solid #fff;
  box-sizing: border-box;
  width: 206px;
  height: 60px;
  flex-shrink: 0;
  overflow: hidden;
  padding: 6px 25px;
  justify-content: center;
  z-index: 1;
  align-self: center;
}
.item13 {
  align-self: stretch;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 1px;
}
.text23 {
  position: relative;
  line-height: 160%;
  display: inline-block;
  width: 297px;
  /* flex-shrink: 0; */
}
.list-items2 {
  top: 149px;
  left: 140px;
  width: 434px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 18px;
}
.button5,
.divider {
  box-sizing: border-box;
}
.button5 {
  top: 567px;
  left: 140px;
  border-radius: 10px;
  background: linear-gradient(-71.92deg, #0076ff, #0076ff);
  width: 434px;
  height: 50px;
  display: flex;
  flex-direction: row;
  padding: 16px 24px;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.divider {
  top: 171.5px;
  left: 619.5px;
  border-right: 1px solid #e7e9f2;
  width: 1px;
  height: 335px;
}
.subtitle,
.text25 {
  position: relative;
  display: inline-block;
}
.subtitle {
  line-height: 140%;
  font-weight: 500;
  width: 153px;
}
.text25 {
  font-size: 16px;
  line-height: 160%;
  color: #3f4872;
  width: 434px;
}
.text-block,
.text-block-parent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 5px;
}
.text-block-parent {
  top: 149px;
  left: 666px;
  height: 378px;
  gap: 18px;
  font-size: 18px;
  color: #000e4e;
}
.identityiq-registered-2-1-icon {
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  object-fit: cover;
}
.identityiq-registered-2-2 {
  align-self: stretch;
  flex: 1;
  position: relative;
}
.button6,
.logo-company2 {
  top: 54px;
  left: 481px;
  width: 278px;
  height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.button6 {
  top: 565.5px;
  left: 664.5px;
  border-radius: 10px;
  border: 1.5px solid #0076ff;
  box-sizing: border-box;
  width: 437px;
  height: 53px;
  flex-direction: row;
  padding: 12px 30px;
  color: #0076ff;
}
.identity-iq {
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 6px 40px rgba(0, 118, 255, 0.1);
  border: 3px solid #0076ff;
  box-sizing: border-box;
  flex-shrink: 0;
  overflow: hidden;
  z-index: 0;
  margin-top: -25px;
  color: #3f4872;
}

.identity {
  top: 727px;
  left: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #fff;
}
.disputely-logo-new-2-1-icon {
  position: relative;
  width: 106px;
  height: 34px;
  flex-shrink: 0;
  overflow: hidden;
}
.dashboard {
  position: relative;
  line-height: 140%;
  font-weight: 600;
  background: linear-gradient(-71.92deg, #0076ff, #0076ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.menu-buttons {
  height: 40px;
  display: flex;
  flex-direction: row;
  padding: 8px 12px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
}
.menu-buttons-child {
  position: relative;
  width: 8px;
  height: 8px;
  flex-shrink: 0;
}
.menu-buttons3,
.nav-bar {
  flex-direction: row;
  align-items: center;
}
.menu-buttons3 {
  height: 40px;
  display: flex;
  padding: 8px 12px;
  box-sizing: border-box;
  justify-content: center;
  gap: 8px;
}
.nav-bar {
  display: none;
  justify-content: flex-start;
  gap: 20px;
}
.notification-icon,
.photo-icon {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
.notification-icon {
  display: none;
}
.photo-icon {
  object-fit: cover;
}
.header,
.icons22 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.icons22 {
  justify-content: flex-start;
  gap: 20px;
}
.header {
  top: 30px;
  left: 100px;
  width: 1240px;
  justify-content: space-between;
  text-align: center;
}
.copyright,
.supporting-text2 {
  font-size: 14px;
  line-height: 160%;
}
.supporting-text2 {
  top: 114px;
  left: 100px;
  font-weight: 500;
  display: inline-block;
  width: 387px;
}
.copyright {
  top: 266px;
  left: 1104px;
  color: #c8ccdf;
}
.privacy-policy {
  position: relative;
  line-height: 100%;
  font-weight: 500;
}
.footer-link,
.footer-link2 {
  top: 60px;
  left: 1052px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 18px;
}
.footer-link {
  left: 841px;
}
.button7,
.divider1 {
  box-sizing: border-box;
}
.divider1 {
  top: 251.5px;
  left: -0.5px;
  border-top: 1px solid #3f4872;
  width: 1441px;
  height: 1px;
}
.button7 {
  top: 188px;
  left: 100px;
  border-radius: 10px;
  background-color: #fff;
  height: 44px;
  display: flex;
  flex-direction: row;
  padding: 12px 30px;
  align-items: center;
  justify-content: center;
  color: #000e4e;
}
.disputely-logo-new-2-1-icon1,
.footer {
  top: 60px;
  left: 100px;
  width: 106px;
  height: 34px;
  overflow: hidden;
}
.footer {
  top: 2458px;
  left: 0;
  background-color: #000e4e;
  width: 1440px;
  height: 320px;
  font-size: 16px;
  color: #e7e9f2;
}
.registration-step-1 {
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 2778px;
  overflow: hidden;
  text-align: left;
  font-size: 18px;
  color: #000e4e;
}

label.text-light-gray.form-label.form-label {
  font-size: 12px;
}

input.form-control.form-control-lg {
  font-size: 16px;
}

.text-medium-22 {
  color: var(--bs-dark-blue);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 160%;
}

.text-medium-18 {
  color: var(--bs-dark-blue);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
}

.text-regular-18 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 140%;
}

.text-medium-16 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
}

.text-semibold-16 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
}

.text-regular-16 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 160%;
}

.text-medium-14 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
}

.text-regular-14 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 160%;
}

.text-medium-12 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 160%;
}

.text-regular-12 {
  color: var(--bs-gray-200);
  font-family: 'Anek Bangla';
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 160%;
}

.container-fluid-1335 {
  max-width: 1335px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

@media (max-width: 576px) {
  .item13 {
    margin: auto 1rem auto 1rem;
  }
}
.caret-off::before {
  display: none;
}
.caret-off::after {
  display: none;
}

.steps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  position: relative;
}
.step-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background-color: var(--prm-gray);
  transition: 0.4s;
}
.step-button[aria-expanded='true'] {
  width: 25px;
  height: 25px;
  font-size: 12px;
}
.done {
  background-color: var(--prm-color);
  color: #fff;
}
.step-item {
  z-index: 10;
  text-align: center;
  margin-top: 1.5rem;
}
#progress {
  -webkit-appearance: none;
  position: absolute;
  width: 100%;
  z-index: 5;
  border: #c8ccdf dashed;
  border-width: 3px 0px 0px 0px;
  top: 6.75rem;
}

#progress-complete {
  -webkit-appearance: none;
  position: absolute;
  width: 100%;
  z-index: 5;
  border: rgb(var(--bs-primary-rgb)) solid;
  border-width: 3px 0px 0px 0px;
  top: 6.75rem;
}
/* to customize progress bar */

#progress::-webkit-progress-value {
  background-color: var(--prm-color);
  transition: 0.5s ease;
}
#progress::-webkit-progress-bar {
  background-color: var(--prm-gray);
}
.step-title {
  width: 120px;
  color: #7c84a5;
  font-weight: 400;
  text-align: center;
  margin-bottom: 1.5rem;
}
.completed .step-title {
  text-align: center;
  font-weight: 500;
  color: #000e4e;
}
.active .step-title {
  font-weight: 500;
  color: #0076ff;
}
.audit-heading {
  color: var(--grayscaledark-blue);
  font-family: var(--font-family-anek_bangla);
  font-size: var(--font-size-xl);
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
  line-height: 30.8px;
}
.supporting-text {
  color: var(--grayscalelight-blue);
  font-family: var(--font-family-anek_bangla);
  font-size: var(--font-size-l);
  letter-spacing: 0;
  width: -moz-fit-content;
  width: fit-content;
  font-weight: 500;
  line-height: 25.2px;
}
.report-audit .credit-box .x-account {
  align-items: center;
  background-color: var(--grayscalewhite);
  border: 2px solid;
  border-color: transparent;
  border-image: linear-gradient(to bottom, rgb(60.56, 138.34, 255), rgb(72.25, 157.1, 255)) 1;
  border-radius: 16px;
  box-shadow: 0px 6px 40px #0076ff1a;
  display: flex;
  padding: 26px 30px;
  margin: 2px auto;
}
.report-audit .credit-box .x-account .item-group .number {
  color: var(--grayscaledark-blue);
  font-family: var(--font-family-anek_bangla);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
  margin-top: -1px;
  line-height: 36px;
}
.report-audit .credit-box .x-account .item-group .text {
  color: var(--grayscalegray200);
  font-family: var(--font-family-anek_bangla);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0;
  white-space: nowrap;
  line-height: 25.6px;
}
.report-audit .credit-box .status {
  height: 40px;
  width: 40px;
  background: linear-gradient(#4ebda9 0%, #ace7dc 100%);
  border-radius: 100px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  display: flex;
  position: relative;
  box-shadow: 0 4px 12px #4882ff1f;
  top: -12px;
}
.report-audit .credit-box .status-1 {
  background: linear-gradient(#fd7d7d 0%, #fda4a4 100%);
}
.report-audit .credit-box .status-2 {
  background: linear-gradient(#f06bb3 0%, #f3add3 100%);
}
.report-audit .credit-box .status-3 {
  background: linear-gradient(#7e69fe80 0%, #2300ff80 100%);
}
.report-audit .credit-box .status-4 {
  background: linear-gradient(#0060ef80 0%, #0076ff80 100%);
}

.btn-light-blue {
  --bs-btn-color: #fff;
  background: linear-gradient(288.08deg, #ebf4ff 0%, #ebf4ff 100%);
  --bs-btn-border-color: #b3d6ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0060ef;
  --bs-btn-hover-border-color: #b3d6ff;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0076ff;
  --bs-btn-disabled-border-color: #0076ff;
}

.bg-teal {
  background-color: var(--bs-teal);
}

.bg-orange {
  background-color: var(--bs-orange);
}

.bg-light-blue {
  background: linear-gradient(288.08deg, #ebf4ff 0%, #ebf4ff 100%);
}

.bg-light-gray {
  background: linear-gradient(288.08deg, var(--bs-gray-ultra-light) 0%, var(--bs-gray-ultra-light) 100%);
}

.bg-white {
  background-color: white;
}

.bg-light-gray {
  background-color: var(--bs-light-gray);
}

.border-light-gray {
  --bs-border-opacity: 1;
  border-color: var(--bs-light-gray) !important;
}

.border-dark-blue {
  --bs-border-opacity: 1;
  border-color: var(--bs-dark-blue) !important;
}

.border-card-cap {
  --bs-border-opacity: 1;
  border-color: var(--bs-card-cap-color) !important;
}

.bg-icon-violet {
  background: linear-gradient(288.08deg, rgba(126, 105, 254, 0.5) 0%, rgba(35, 0, 255, 0.5) 100%);
}

.bg-icon-green {
  background: linear-gradient(288.08deg, rgb(78, 189, 169) 0%, rgb(172, 231, 220) 100%);
}

.bg-icon-red {
  background: linear-gradient(288.08deg, rgb(253, 125, 125) 0%, rgb(253, 164, 164) 100%);
}

.bg-icon-blue {
  background: linear-gradient(288.08deg, #0076ff 0%, #248aff 100%);
}
/* utility class for w-x in increments of 5 */
.w-5 {
  width: 5% !important;
}
.w-10 {
  width: 10% !important;
}
.w-15 {
  width: 15% !important;
}
.w-20 {
  width: 20% !important;
}
.w-25 {
  width: 25% !important;
}
.w-30 {
  width: 30% !important;
}
.w-35 {
  width: 35% !important;
}
.w-40 {
  width: 40% !important;
}
.w-45 {
  width: 45% !important;
}
.w-50 {
  width: 50% !important;
}
.w-55 {
  width: 55% !important;
}
.w-60 {
  width: 60% !important;
}
.w-65 {
  width: 65% !important;
}
.w-70 {
  width: 70% !important;
}
.w-75 {
  width: 75% !important;
}
.w-80 {
  width: 80% !important;
}
.w-85 {
  width: 85% !important;
}
.w-90 {
  width: 90% !important;
}
.w-95 {
  width: 95% !important;
}

/* utility class for w-{size}-x in increments of 5 */
@media (min-width: 576px) {
  .w-sm-5 {
    width: 5% !important;
  }
  .w-sm-10 {
    width: 10% !important;
  }
  .w-sm-15 {
    width: 15% !important;
  }
  .w-sm-20 {
    width: 20% !important;
  }
  .w-sm-25 {
    width: 25% !important;
  }
  .w-sm-30 {
    width: 30% !important;
  }
  .w-sm-35 {
    width: 35% !important;
  }
  .w-sm-40 {
    width: 40% !important;
  }
  .w-sm-45 {
    width: 45% !important;
  }
  .w-sm-50 {
    width: 50% !important;
  }
  .w-sm-55 {
    width: 55% !important;
  }
  .w-sm-60 {
    width: 60% !important;
  }
  .w-sm-65 {
    width: 65% !important;
  }
  .w-sm-70 {
    width: 70% !important;
  }
  .w-sm-75 {
    width: 75% !important;
  }
  .w-sm-80 {
    width: 80% !important;
  }
  .w-sm-85 {
    width: 85% !important;
  }
  .w-sm-90 {
    width: 90% !important;
  }
  .w-sm-95 {
    width: 95% !important;
  }
}

@media (min-width: 768px) {
  .w-md-5 {
    width: 5% !important;
  }
  .w-md-10 {
    width: 10% !important;
  }
  .w-md-15 {
    width: 15% !important;
  }
  .w-md-20 {
    width: 20% !important;
  }
  .w-md-25 {
    width: 25% !important;
  }
  .w-md-30 {
    width: 30% !important;
  }
  .w-md-35 {
    width: 35% !important;
  }
  .w-md-40 {
    width: 40% !important;
  }
  .w-md-45 {
    width: 45% !important;
  }
  .w-md-50 {
    width: 50% !important;
  }
  .w-md-55 {
    width: 55% !important;
  }
  .w-md-60 {
    width: 60% !important;
  }
  .w-md-65 {
    width: 65% !important;
  }
  .w-md-70 {
    width: 70% !important;
  }
  .w-md-80 {
    width: 80% !important;
  }
  .w-md-85 {
    width: 85% !important;
  }
  .w-md-90 {
    width: 90% !important;
  }
  .w-md-95 {
    width: 95% !important;
  }
}

/* Utility classes for large screens (min-width: 992px) */
@media (min-width: 992px) {
  .w-lg-5 {
    width: 5% !important;
  }
  .w-lg-10 {
    width: 10% !important;
  }
  .w-lg-15 {
    width: 15% !important;
  }
  .w-lg-20 {
    width: 20% !important;
  }
  .w-lg-30 {
    width: 30% !important;
  }
  .w-lg-35 {
    width: 35% !important;
  }
  .w-lg-40 {
    width: 40% !important;
  }
  .w-lg-45 {
    width: 45% !important;
  }
  .w-lg-50 {
    width: 50% !important;
  }
  .w-lg-55 {
    width: 55% !important;
  }
  .w-lg-60 {
    width: 60% !important;
  }
  .w-lg-65 {
    width: 65% !important;
  }
  .w-lg-70 {
    width: 70% !important;
  }
  .w-lg-80 {
    width: 80% !important;
  }
  .w-lg-85 {
    width: 85% !important;
  }
  .w-lg-90 {
    width: 90% !important;
  }
  .w-lg-95 {
    width: 95% !important;
  }
}

/* Utility classes for extra large screens (min-width: 1200px) */
@media (min-width: 1200px) {
  .w-xl-5 {
    width: 5% !important;
  }
  .w-xl-10 {
    width: 10% !important;
  }
  .w-xl-15 {
    width: 15% !important;
  }
  .w-xl-20 {
    width: 20% !important;
  }
  .w-xl-30 {
    width: 30% !important;
  }
  .w-xl-35 {
    width: 35% !important;
  }
  .w-xl-40 {
    width: 40% !important;
  }
  .w-xl-45 {
    width: 45% !important;
  }
  .w-xl-50 {
    width: 50% !important;
  }
  .w-xl-55 {
    width: 55% !important;
  }
  .w-xl-60 {
    width: 60% !important;
  }
  .w-xl-65 {
    width: 65% !important;
  }
  .w-xl-70 {
    width: 70% !important;
  }
  .w-xl-80 {
    width: 80% !important;
  }
  .w-xl-85 {
    width: 85% !important;
  }
  .w-xl-90 {
    width: 90% !important;
  }
  .w-xl-95 {
    width: 95% !important;
  }
}

/* Utility classes for large screens (min-width: 992px) */
@media (min-width: 992px) {
  .w-lg-5 {
    width: 5% !important;
  }
  .w-lg-10 {
    width: 10% !important;
  }
  .w-lg-15 {
    width: 15% !important;
  }
  .w-lg-20 {
    width: 20% !important;
  }
  .w-lg-30 {
    width: 30% !important;
  }
  .w-lg-35 {
    width: 35% !important;
  }
  .w-lg-40 {
    width: 40% !important;
  }
  .w-lg-45 {
    width: 45% !important;
  }
  .w-lg-50 {
    width: 50% !important;
  }
  .w-lg-55 {
    width: 55% !important;
  }
  .w-lg-60 {
    width: 60% !important;
  }
  .w-lg-65 {
    width: 65% !important;
  }
  .w-lg-70 {
    width: 70% !important;
  }
  .w-lg-80 {
    width: 80% !important;
  }
  .w-lg-85 {
    width: 85% !important;
  }
  .w-lg-90 {
    width: 90% !important;
  }
  .w-lg-95 {
    width: 95% !important;
  }
}

/* Utility classes for medium screens (min-width: 768px) */
@media (min-width: 768px) {
  .w-md-5 {
    width: 5% !important;
  }
  .w-md-10 {
    width: 10% !important;
  }
  .w-md-15 {
    width: 15% !important;
  }
  .w-md-20 {
    width: 20% !important;
  }
  .w-md-30 {
    width: 30% !important;
  }
  .w-md-35 {
    width: 35% !important;
  }
  .w-md-40 {
    width: 40% !important;
  }
  .w-md-45 {
    width: 45% !important;
  }
  .w-md-50 {
    width: 50% !important;
  }
  .w-md-55 {
    width: 55% !important;
  }
  .w-md-60 {
    width: 60% !important;
  }
  .w-md-65 {
    width: 65% !important;
  }
  .w-md-70 {
    width: 70% !important;
  }
  .w-md-80 {
    width: 80% !important;
  }
  .w-md-85 {
    width: 85% !important;
  }
  .w-md-90 {
    width: 90% !important;
  }
  .w-md-95 {
    width: 95% !important;
  }
}
/* Utility classes for small screens (min-width: 576px) */
@media (min-width: 576px) {
  .w-sm-5 {
    width: 5% !important;
  }
  .w-sm-10 {
    width: 10% !important;
  }
  .w-sm-15 {
    width: 15% !important;
  }
  .w-sm-20 {
    width: 20% !important;
  }
  .w-sm-30 {
    width: 30% !important;
  }
  .w-sm-35 {
    width: 35% !important;
  }
  .w-sm-40 {
    width: 40% !important;
  }
  .w-sm-45 {
    width: 45% !important;
  }
  .w-sm-50 {
    width: 50% !important;
  }
  .w-sm-55 {
    width: 55% !important;
  }
  .w-sm-60 {
    width: 60% !important;
  }
  .w-sm-65 {
    width: 65% !important;
  }
  .w-sm-70 {
    width: 70% !important;
  }
  .w-sm-80 {
    width: 80% !important;
  }
  .w-sm-85 {
    width: 85% !important;
  }
  .w-sm-90 {
    width: 90% !important;
  }
  .w-sm-95 {
    width: 95% !important;
  }
}

.shadow-more {
  box-shadow: 0 6px 40px 0 rgb(var(--bs-primary-rgb), 0.5) !important;
}

.navbar {
  border-bottom: 0;
  box-shadow: none !important;
}

.navbar .nav-link {
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  margin: auto 1rem;
}

/* Extra small devices (portrait phones, less than 576px) */
/* No changes needed, default Bootstrap behavior is mobile-first */

/* Small devices (landscape phones, 576px and up) */
/* No changes needed, default Bootstrap behavior is mobile-first */

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .position-static-md {
    position: static !important;
  }
  .position-relative-md {
    position: relative !important;
  }
  .position-absolute-md {
    position: absolute !important;
  }
  .position-fixed-md {
    position: fixed !important;
  }
  .position-sticky-md {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .position-static-lg {
    position: static !important;
  }
  .position-relative-lg {
    position: relative !important;
  }
  .position-absolute-lg {
    position: absolute !important;
  }
  .position-fixed-lg {
    position: fixed !important;
  }
  .position-sticky-lg {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .position-static-xl {
    position: static !important;
  }
  .position-relative-xl {
    position: relative !important;
  }
  .position-absolute-xl {
    position: absolute !important;
  }
  .position-fixed-xl {
    position: fixed !important;
  }
  .position-sticky-xl {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

.visibility-hidden {
  visibility: hidden !important;
}

.swal-confirm-button {
  color: #fff !important;
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  padding: 0.25rem 2rem !important;
  font-size: 1.25rem !important;
  line-height: 1.5 !important;
  border-radius: 0.3rem !important;
  font-weight: 300 !important;
}

.swal-deny-button {
  color: #fff !important;
  background-color: var(--bs-danger) !important;
  border-color: #6c757d !important;
  padding: 0.25rem 2rem !important;
  font-size: 1.25rem !important;
  line-height: 1.5 !important;
  border-radius: 0.3rem !important;
  font-weight: 300 !important;
}

@media (max-width: 768px) {
  .mobile-overflow-x-auto {
    overflow-x: auto !important;
    table-layout: auto !important;
  }

  .mobile-overflow-x-auto thead,
  .mobile-overflow-x-auto td {
    white-space: nowrap !important;
  }
}

.infoButton.popover {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}

.infoButton.popover .popover-header {
  background-color: #fff;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}

.infoButton.popover .popover-body {
  font-size: 14px;
  line-height: 1.5;
  text-align: justify;
}

/* REPORT AUDIT SWITCH */

.switch {
  position: relative;
  display: block;
  vertical-align: top;
  width: 120px;
  height: 30px;
  padding: 3px;
  margin: auto auto auto 0;
  background: linear-gradient(to bottom, #eeeeee, #ffffff 25px);
  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff 25px);
  border-radius: 18px;
  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  box-sizing: content-box;
}
.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  box-sizing: content-box;
}
.switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  background: #eceeef;
  border-radius: inherit;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12), inset 0 0 2px rgba(0, 0, 0, 0.15);
  box-sizing: content-box;
}
.switch-label:before,
.switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -0.5em;
  line-height: 1;
  -webkit-transition: inherit;
  -moz-transition: inherit;
  -o-transition: inherit;
  transition: inherit;
  box-sizing: content-box;
}
.switch-label:before {
  content: attr(data-off);
  right: 11px;
  font-weight: 500;
  color: var(--bs-dark-blue);
  text-shadow: 0 1px rgba(255, 255, 255, 0.5);
}
.switch-label:after {
  content: attr(data-on);
  left: 11px;
  color: #ffffff;
  text-shadow: 0 1px rgba(0, 0, 0, 0.2);
  opacity: 0;
}
.switch-input:checked ~ .switch-label {
  background: linear-gradient(90deg, #ff2b2b 0%, #f66 100%);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2);
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}
.switch-handle {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 28px;
  height: 28px;
  background: linear-gradient(to bottom, #ffffff 40%, #f0f0f0);
  background-image: -webkit-linear-gradient(top, #ffffff 40%, #f0f0f0);
  border-radius: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}
.switch-handle:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -6px;
  width: 12px;
  height: 12px;
  background: linear-gradient(to bottom, #eeeeee, #ffffff);
  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff);
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
}
.switch-input:checked ~ .switch-handle {
  left: 94px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
}

/* Transition
========================== */
.switch-label,
.switch-handle {
  transition: All 0.3s ease;
  -webkit-transition: All 0.3s ease;
  -moz-transition: All 0.3s ease;
  -o-transition: All 0.3s ease;
}

#launcher-frame {
  bottom: 63px;
}
.react-joyride__tooltip button {
  background-color: #0076ff !important; /* Change this to your desired color */
  border-color: #0076ff !important; /* Change this to your desired color */
}

/* Change the button hover background color */
.react-joyride__tooltip button:hover {
  background-color: #1b1848 !important; /* Change this to your desired hover color */
  border-color: #0076ff !important; /* Change this to your desired hover color */
}

/* Change the button properties */
.react-joyride__tooltip button[type='button'][data-action='back'] {
  appearance: none !important;
  background-color: transparent !important;
  border-style: none !important;
  color: #0076ff !important;
  cursor: pointer !important;
  font-family: 'Anek Bangla', sans-serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  margin: 0 !important;
  margin-right: auto !important;
  padding: 8px !important;
  text-align: center !important;
  text-transform: none !important;
  visibility: visible !important;
}
.react-joyride__tooltip button[type='button'][data-action='skip'] {
  appearance: none !important;
  background-color: transparent !important;
  border-style: none !important;
  color: #0076ff !important;
  cursor: pointer !important;
  font-family: 'Anek Bangla', sans-serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  margin: 0 !important;
  margin-right: auto !important;
  padding: 8px !important;
  text-align: center !important;
  text-transform: none !important;
  visibility: visible !important;
}

.main {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.content {
  max-width: 100% !important;
}

.sonar-wrapper {
  position: absolute;
  top: 25px;
  right: 55px;
}

.sonar-effect {
  top: -2px;
  left: -2px;
  bottom: 0;
  z-index: 0;
  border-radius: 50%;
  opacity: 0;
  animation: sonar-animation 2s linear infinite;
  background: #dc3545;
  padding: 1.2rem;
}
.sonar-effect-green{
background: #41a995 !important;
}

.number-sonar {
	top: -3px;
	left: -3px;
	bottom: 0;
	z-index: 0;
	border-radius: 50%;
	opacity: 0;
	animation: sonar-animation 2s linear infinite;

	padding: 1.2rem;
}

@keyframes sonar-animation {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: .8;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.btn-sonar-effect{
  transition: all .3s;
  -webkit-transition: all .3s;
  -moz-transition: all .3s;
  animation: sonar-btn 1s ease-in-out infinite;
}

.btn-sonar-effect:after {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50px;
  content: '';
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}

.btn-sonar-effect:after {
  top: 0;
  left: 0;
  padding: 0;
  z-index: 0;
  box-shadow: 0 0 0 2px rgba(252, 0, 0, 0.1);
  opacity: 0;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  transform: scale(0.7);
  -webkit-animation: sonarEffect .5s ease-out infinite;
  -moz-animation: sonarEffect .5s ease-out infinite;
  animation: sonarEffect .5s ease-out infinite;
}

@keyframes sonarEffect {
  0% {
    opacity: 0.3;
}

40% {
    opacity: 0.7;
    box-shadow: 0 0 0 2px rgba(231, 9, 9, 0.1), 0 0 1px 2px #4e3f41;
}

100% {
    box-shadow: 0 0 0 2px rgba(255, 94, 94, 0.1), 0 0 1px 2px rgba(37, 37, 37, 0.5);
    -webkit-transform: scale(1.03);
    opacity: 0;
}
}

@keyframes sonar-btn {
  0% {
    transform: scale(1);
  }

  40% {
    transform: scale(0.95);
  }
  60%{
    transform: scale(0.98);
  }

  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;;EAGE,iDAAiD;EACjD,sBAAsB;AACxB;AACA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gEAAgE;EAChE,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,yCAAyC;EACzC,mCAAmC;EACnC,8DAA8D;EAC9D,qCAAqC;EACrC,kDAAkD;EAClD,0EAA0E;EAC1E,4DAA4D;EAC5D,sCAAsC;EACtC,4EAA4E;EAC5E,8CAA8C;EAC9C,oDAAoD;EACpD,kDAAkD;EAClD,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;EAC1C,kCAAkC;EAClC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,uCAAuC;EACvC,kEAAkE;EAClE,SAAS;EACT,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,4BAA4B;EAC5B,6EAA6E;EAC7E,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,8DAA8D;EAC9D,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,4DAA4D;EAC5D,sDAAsD;EACtD,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,2CAA2C;EAC3C,qCAAqC;EACrC,oDAAoD;EACpD,oDAAoD;EACpD,sDAAsD;EACtD,uDAAuD;EACvD,+CAA+C;EAC/C,0DAA0D;EAC1D,uDAAuD;EACvD,gDAAgD;EAChD,wEAAwE;EACxE,kCAAkC;EAClC,kCAAkC;EAClC,4CAA4C;EAC5C,yDAAyD;EACzD,mDAAmD;EACnD,6DAA6D;EAC7D,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,gCAAgC;EAChC,wCAAwC;EACxC,oDAAoD;EACpD,oDAAoD;EACpD,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;EACvC,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,oDAAoD;EACpD,oDAAoD;EACpD,sDAAsD;EACtD,oCAAoC;EACpC,sCAAsC;EACtC,uDAAuD;EACvD,4DAA4D;EAC5D,sDAAsD;EACtD,yDAAyD;EACzD,wDAAwD;EACxD,yDAAyD;EACzD,8CAA8C;EAC9C,kCAAkC;EAClC,kCAAkC;EAClC,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,UAAU;AACZ;;AAEA;;EAEE,yCAAyC;EACzC,qCAAqC;EACrC,UAAU,EAAE,YAAY;AAC1B;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,UAAU,EAAE,YAAY;AAC1B;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,OAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;;;EAGE,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wDAAwD;EACxD,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;;;EAGE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wDAAwD;EACxD,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;AACX;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wDAAwD;EACxD,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,OAAO;EACP,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wDAAwD;EACxD,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,wCAAwC;EACxC,6BAA6B;EAC7B,YAAY;AACd;AACA,8BAA8B;;AAE9B;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,yBAAyB;EACzB,2FAA2F;EAC3F,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,qDAAqD;EACrD,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,gEAAgE;EAChE,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,sGAAsG;AACxG;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,+FAA+F;AACjG;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,gEAAgE;AAClE;AACA,6CAA6C;AAC7C;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA,yDAAyD;AACzD;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D,kEAAkE;;AAElE,mDAAmD;AACnD,kEAAkE;;AAElE,2CAA2C;AAC3C;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,6DAA6D;EAC7D,qEAAqE;EACrE,mBAAmB;EACnB,mEAAmE;EACnE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kFAAkF;EAClF,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,yDAAyD;EACzD,iFAAiF;AACnF;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,oEAAoE;EACpE,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,gEAAgE;EAChE,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;4BAC4B;AAC5B;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;AACA;EACE,oCAAoC,EAAE,sCAAsC;EAC5E,gCAAgC,EAAE,sCAAsC;AAC1E;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC,EAAE,4CAA4C;EAClF,gCAAgC,EAAE,4CAA4C;AAChF;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,iDAAiD;EACjD,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,iDAAiD;EACjD,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;AACjB;AACA;AACA,8BAA8B;AAC9B;;AAEA;CACC,SAAS;CACT,UAAU;CACV,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,UAAU;CACV,6CAA6C;;CAE7C,eAAe;AAChB;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,UAAU;EACV,UAAU;EACV,0CAA0C;EAC1C,UAAU;EACV,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,oDAAoD;EACpD,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;EACE;IACE,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,+DAA+D;AACnE;;AAEA;IACI,+EAA+E;IAC/E,8BAA8B;IAC9B,UAAU;AACd;AACA;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url('https://fonts.googleapis.com/css2?family=Anek+Bangla:wght@100;200;300;400;500;600;700;800&display=swap');\n\n:root,\n[data-bs-theme='light'] {\n  --bs-blue: #0076ff;\n  --bs-gray-dark: #343a40;\n  --bs-gray-light: #a2a7c0;\n  --bs-gray-ultra-light: #e6e6e6;\n  --bs-gray-100: #e7e9f2;\n  --bs-gray-200: #3f4872;\n  --bs-gray-400: #7c84a5;\n  --bs-primary: #0076ff;\n  --bs-dark-blue: #000e4e;\n  --bs-light-blue: #57608a;\n  --bs-primary-rgb: 0, 118, 255;\n  --bs-link-color: #0076ff;\n  --bs-light-gray: #a2a7c0;\n  --bs-success: #41a895;\n  --bs-success-rgb: 65, 168, 149;\n  --bs-danger: #eb0000;\n  --bs-warning: #fccb4f;\n}\n*,\n::after,\n::before {\n  font-family: 'Anek Bangla', sans-serif !important;\n  box-sizing: border-box;\n}\n.h1,\nh1 {\n  font-size: 44px !important;\n  font-weight: 600 !important;\n  color: var(--bs-dark-blue) !important;\n}\n\n.h2,\nh2 {\n  font-size: 30px !important;\n  font-weight: 600 !important;\n  color: var(--bs-dark-blue) !important;\n}\n\n.h3,\nh3 {\n  font-size: 22px !important;\n  font-weight: 600 !important;\n  color: var(--bs-dark-blue) !important;\n}\n\n.h4,\nh4 {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: var(--bs-dark-blue) !important;\n}\n\n.form-control {\n  border: var(--bs-border-width) solid var(--bs-light-gray);\n}\n.form-check-input:checked {\n  background-color: #0076ff;\n  border-color: #0076ff;\n}\n\n.form-range::-webkit-slider-thumb {\n  background-color: #0076ff;\n}\n.btn-primary {\n  background: linear-gradient(288.08deg, #0076ff 0%, #0076ff 100%);\n  --bs-btn-border-color: #0076ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0060ef;\n  --bs-btn-hover-border-color: #0076ff;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a58ca;\n  --bs-btn-active-border-color: #0a53be;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0076ff;\n  --bs-btn-disabled-border-color: #0076ff;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0076ff;\n  --bs-btn-border-color: #0076ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0076ff;\n  --bs-btn-hover-border-color: #0076ff;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0076ff;\n  --bs-btn-active-border-color: #0076ff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0076ff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0076ff;\n  --bs-gradient: none;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0.375rem;\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(0.375rem - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(var(--bs-body-color-rgb), 0.15);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0076ff;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0076ff;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 0.375rem;\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0076ff;\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0076ff;\n  --bs-pagination-active-border-color: #0076ff;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0076ff;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0076ff;\n  --bs-list-group-active-border-color: #0076ff;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.link-primary {\n  color: #0076ff !important;\n}\n\n.shadow {\n  box-shadow: 0px 10px 20px 5px rgb(var(--bs-primary-rgb), 0.1) !important;\n}\n\n.shadow::before {\n  z-index: -1;\n}\n\n.fs-16 {\n  font-size: 16px !important;\n}\n\n.fs-18 {\n  font-size: 18px !important;\n}\n\n.text-dark-blue {\n  --bs-text-opacity: 1;\n  color: var(--bs-dark-blue) !important;\n}\n\n.text-gray-200 {\n  --bs-text-opacity: 1;\n  color: var(--bs-gray-200) !important;\n}\n\n.text-light-gray {\n  --bs-text-opacity: 1;\n  color: var(--bs-light-gray) !important;\n}\n\n.text-gray-400 {\n  --bs-text-opacity: 1;\n  color: var(--bs-gray-400) !important;\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n}\n\ninput {\n  border-radius: 10px;\n}\n\n.login-divider {\n  width: 50%;\n  text-align: center;\n  border-bottom: 1px solid var(--bs-light-gray);\n  line-height: 0.1em;\n  margin: auto;\n}\n\n.login-divider span {\n  background: #fff;\n  padding: 0 10px;\n  color: var(--bs-light-gray);\n}\n\n.form-control::placeholder {\n  color: var(--bs-light-gray) !important;\n  opacity: 1;\n}\n\n.form-control,\n.form-control .form-control-lg {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: var(--bs-dark-blue) !important;\n  opacity: 1; /* Firefox */\n}\n\n.form-control:focus {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: var(--bs-dark-blue) !important;\n  opacity: 1; /* Firefox */\n}\n\n/* CHOOSE REPORT  */\n.lines-icon {\n  top: 69.19px;\n  left: 0;\n  width: 1225.01px;\n  height: 3px;\n}\n.div {\n  position: relative;\n  line-height: 120%;\n  font-weight: 600;\n}\n.tick {\n  top: 2px;\n  left: 0;\n  border-radius: 100px;\n  background-color: #f8f9fd;\n  border: 2px solid #0076ff;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  align-items: center;\n  justify-content: center;\n  color: #0076ff;\n}\n.tick,\n.tick1,\n.tick2 {\n  position: absolute;\n}\n.tick1 {\n  top: 0;\n  left: 260px;\n  border-radius: 100px;\n  background-color: #fff;\n  border: 2px solid #c8ccdf;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  align-items: center;\n  justify-content: center;\n}\n.tick2 {\n  top: 2px;\n  left: 482px;\n}\n.tick2,\n.tick3,\n.tick4 {\n  border-radius: 100px;\n  background-color: #fff;\n  border: 2px solid #c8ccdf;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  align-items: center;\n  justify-content: center;\n}\n.tick3 {\n  position: absolute;\n  top: 2px;\n  left: 710px;\n}\n.tick4 {\n  top: 3px;\n  left: 938px;\n}\n.tick4,\n.tick5,\n.ticks {\n  position: absolute;\n}\n.tick5 {\n  top: 2px;\n  left: 1216px;\n  border-radius: 100px;\n  background-color: #fff;\n  border: 2px solid #c8ccdf;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  align-items: center;\n  justify-content: center;\n}\n.ticks {\n  top: 57px;\n  left: 0;\n  width: 1240px;\n  height: 27px;\n}\n.upload-credit-reports {\n  position: relative;\n  line-height: 120%;\n  font-weight: 600;\n  color: #0076ff;\n  text-align: left;\n  display: inline-block;\n  width: 111px;\n  flex-shrink: 0;\n}\n.choose-items {\n  margin-block-start: 0;\n  margin-block-end: 0;\n}\n.to-be-disputed {\n  margin: 0;\n}\n.choose-items-to-container,\n.confirm-personal-information-container,\n.disputes-created {\n  position: relative;\n  line-height: 120%;\n  display: inline-block;\n  width: 111px;\n  flex-shrink: 0;\n}\n.confirm-personal-information-container,\n.disputes-created {\n  width: 123px;\n}\n.disputes-created {\n  text-align: right;\n}\n.steps {\n  top: 0;\n  left: 0;\n  width: 1240px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 16px;\n  color: #7c84a5;\n  scrollbar-width: none;\n}\n.steps::-webkit-scrollbar{\n  display: none;\n}\n.creating-status,\n.heading {\n  left: 100px;\n}\n.creating-status {\n  top: 171px;\n  width: 1240px;\n  height: 84px;\n  text-align: center;\n  font-size: 12px;\n  color: #c8ccdf;\n}\n.heading {\n  top: 120px;\n  font-size: 22px;\n  line-height: 140%;\n  font-weight: 600;\n}\n.heading1,\n.supporting-text,\n.supporting-text1 {\n  position: relative;\n  line-height: 140%;\n  display: inline-block;\n}\n.heading1 {\n  font-weight: 600;\n  width: 103px;\n}\n.supporting-text,\n.supporting-text1 {\n  width: 604px;\n}\n.supporting-text {\n  font-weight: 500;\n}\n.supporting-text1 {\n  color: #7c84a5;\n}\n.heading-supporting-text,\n.text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n.text {\n  justify-content: flex-start;\n  font-size: 18px;\n  color: #3f4872;\n}\n.heading-supporting-text {\n  top: 335px;\n  left: 100px;\n  justify-content: center;\n  font-size: 22px;\n}\n\n.ill-do-this,\n.why-do-you {\n  position: relative;\n  line-height: 140%;\n}\n.why-do-you {\n  display: inline-block;\n  width: 387px;\n  flex-shrink: 0;\n}\n.ill-do-this {\n  font-weight: 500;\n}\n.button {\n  height: 26px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #0076ff;\n}\n.for-more-details {\n  position: relative;\n  line-height: 140%;\n  display: inline-block;\n  width: 121px;\n  flex-shrink: 0;\n}\n.why-do-you-need-to-use-ai-comp-parent {\n  top: 571px;\n  left: 100px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 4px;\n}\n.icons {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n.tick6 {\n  border-radius: 100px;\n  background-color: #0076ff;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n.text1 {\n  flex: 1;\n  position: relative;\n  line-height: 160%;\n}\n.item,\n.list-items {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.item {\n  align-self: stretch;\n  flex-direction: row;\n  gap: 12px;\n}\n.list-items {\n  top: 133px;\n  left: 78px;\n  width: 434px;\n  flex-direction: column;\n  gap: 18px;\n}\n.improve-letters-now {\n  position: relative;\n  line-height: 140%;\n  font-weight: 600;\n}\n.button1 {\n  border-radius: 10px;\n  background: linear-gradient(-71.92deg, #0076ff, #0076ff);\n  width: 434px;\n  height: 50px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  padding: 16px 24px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n}\n.button-icon {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  overflow: hidden;\n  display: none;\n}\n.content {\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 12px;\n}\n.button2,\n.buttons,\n.content {\n  display: flex;\n  /* align-items: center; */\n}\n.button2 {\n  border-radius: 10px;\n  border: 1.5px solid #0076ff;\n  box-sizing: border-box;\n  width: 437px;\n  height: 53px;\n  flex-shrink: 0;\n  flex-direction: row;\n  padding: 12px 30px;\n  justify-content: center;\n  color: #0076ff;\n}\n.buttons {\n  top: 619px;\n  left: 78px;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 16px;\n  color: #fff;\n}\n.download-1-icon {\n  align-self: stretch;\n  flex: 1;\n  position: relative;\n  max-width: 100%;\n  overflow: hidden;\n  max-height: 100%;\n  object-fit: cover;\n}\n.logo-company {\n  top: 50px;\n  left: 150px;\n  width: 290px;\n  height: 53px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.smartcredit {\n  top: 1493px;\n  left: 100px;\n  border-radius: 20px;\n  background-color: #fff;\n  box-shadow: 0 6px 40px rgba(0, 118, 255, 0.1);\n  width: 590px;\n  height: 785px;\n  overflow: hidden;\n  font-size: 16px;\n  color: #3f4872;\n}\n.list-items1,\n.logo-company1 {\n  display: flex;\n  flex-direction: column;\n}\n.list-items1 {\n  top: 127px;\n  left: 78px;\n  width: 434px;\n  height: 446px;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 18px;\n}\n.logo-company1 {\n  top: 50px;\n  left: 207px;\n  width: 177px;\n  height: 47px;\n  align-items: center;\n  justify-content: center;\n}\n.truly-id {\n  top: 1493px;\n  left: 750px;\n  border-radius: 20px;\n  background-color: #fff;\n  box-shadow: 0 6px 40px rgba(0, 118, 255, 0.1);\n  width: 590px;\n  height: 785px;\n  overflow: hidden;\n  font-size: 16px;\n  color: #3f4872;\n}\n.budge,\n.item13 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.budge {\n  border-radius: 10px;\n  background: linear-gradient(-71.92deg, #0076ff, #0076ff);\n  border: 3px solid #fff;\n  box-sizing: border-box;\n  width: 206px;\n  height: 60px;\n  flex-shrink: 0;\n  overflow: hidden;\n  padding: 6px 25px;\n  justify-content: center;\n  z-index: 1;\n  align-self: center;\n}\n.item13 {\n  align-self: stretch;\n  justify-content: flex-start;\n  gap: 12px;\n  margin-bottom: 1px;\n}\n.text23 {\n  position: relative;\n  line-height: 160%;\n  display: inline-block;\n  width: 297px;\n  /* flex-shrink: 0; */\n}\n.list-items2 {\n  top: 149px;\n  left: 140px;\n  width: 434px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 18px;\n}\n.button5,\n.divider {\n  box-sizing: border-box;\n}\n.button5 {\n  top: 567px;\n  left: 140px;\n  border-radius: 10px;\n  background: linear-gradient(-71.92deg, #0076ff, #0076ff);\n  width: 434px;\n  height: 50px;\n  display: flex;\n  flex-direction: row;\n  padding: 16px 24px;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.divider {\n  top: 171.5px;\n  left: 619.5px;\n  border-right: 1px solid #e7e9f2;\n  width: 1px;\n  height: 335px;\n}\n.subtitle,\n.text25 {\n  position: relative;\n  display: inline-block;\n}\n.subtitle {\n  line-height: 140%;\n  font-weight: 500;\n  width: 153px;\n}\n.text25 {\n  font-size: 16px;\n  line-height: 160%;\n  color: #3f4872;\n  width: 434px;\n}\n.text-block,\n.text-block-parent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 5px;\n}\n.text-block-parent {\n  top: 149px;\n  left: 666px;\n  height: 378px;\n  gap: 18px;\n  font-size: 18px;\n  color: #000e4e;\n}\n.identityiq-registered-2-1-icon {\n  height: 100%;\n  width: 100%;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  max-width: 100%;\n  overflow: hidden;\n  max-height: 100%;\n  object-fit: cover;\n}\n.identityiq-registered-2-2 {\n  align-self: stretch;\n  flex: 1;\n  position: relative;\n}\n.button6,\n.logo-company2 {\n  top: 54px;\n  left: 481px;\n  width: 278px;\n  height: 58px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.button6 {\n  top: 565.5px;\n  left: 664.5px;\n  border-radius: 10px;\n  border: 1.5px solid #0076ff;\n  box-sizing: border-box;\n  width: 437px;\n  height: 53px;\n  flex-direction: row;\n  padding: 12px 30px;\n  color: #0076ff;\n}\n.identity-iq {\n  border-radius: 20px;\n  background-color: #fff;\n  box-shadow: 0 6px 40px rgba(0, 118, 255, 0.1);\n  border: 3px solid #0076ff;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  overflow: hidden;\n  z-index: 0;\n  margin-top: -25px;\n  color: #3f4872;\n}\n\n.identity {\n  top: 727px;\n  left: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  color: #fff;\n}\n.disputely-logo-new-2-1-icon {\n  position: relative;\n  width: 106px;\n  height: 34px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n.dashboard {\n  position: relative;\n  line-height: 140%;\n  font-weight: 600;\n  background: linear-gradient(-71.92deg, #0076ff, #0076ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.menu-buttons {\n  height: 40px;\n  display: flex;\n  flex-direction: row;\n  padding: 8px 12px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n}\n.menu-buttons-child {\n  position: relative;\n  width: 8px;\n  height: 8px;\n  flex-shrink: 0;\n}\n.menu-buttons3,\n.nav-bar {\n  flex-direction: row;\n  align-items: center;\n}\n.menu-buttons3 {\n  height: 40px;\n  display: flex;\n  padding: 8px 12px;\n  box-sizing: border-box;\n  justify-content: center;\n  gap: 8px;\n}\n.nav-bar {\n  display: none;\n  justify-content: flex-start;\n  gap: 20px;\n}\n.notification-icon,\n.photo-icon {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n}\n.notification-icon {\n  display: none;\n}\n.photo-icon {\n  object-fit: cover;\n}\n.header,\n.icons22 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.icons22 {\n  justify-content: flex-start;\n  gap: 20px;\n}\n.header {\n  top: 30px;\n  left: 100px;\n  width: 1240px;\n  justify-content: space-between;\n  text-align: center;\n}\n.copyright,\n.supporting-text2 {\n  font-size: 14px;\n  line-height: 160%;\n}\n.supporting-text2 {\n  top: 114px;\n  left: 100px;\n  font-weight: 500;\n  display: inline-block;\n  width: 387px;\n}\n.copyright {\n  top: 266px;\n  left: 1104px;\n  color: #c8ccdf;\n}\n.privacy-policy {\n  position: relative;\n  line-height: 100%;\n  font-weight: 500;\n}\n.footer-link,\n.footer-link2 {\n  top: 60px;\n  left: 1052px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 18px;\n}\n.footer-link {\n  left: 841px;\n}\n.button7,\n.divider1 {\n  box-sizing: border-box;\n}\n.divider1 {\n  top: 251.5px;\n  left: -0.5px;\n  border-top: 1px solid #3f4872;\n  width: 1441px;\n  height: 1px;\n}\n.button7 {\n  top: 188px;\n  left: 100px;\n  border-radius: 10px;\n  background-color: #fff;\n  height: 44px;\n  display: flex;\n  flex-direction: row;\n  padding: 12px 30px;\n  align-items: center;\n  justify-content: center;\n  color: #000e4e;\n}\n.disputely-logo-new-2-1-icon1,\n.footer {\n  top: 60px;\n  left: 100px;\n  width: 106px;\n  height: 34px;\n  overflow: hidden;\n}\n.footer {\n  top: 2458px;\n  left: 0;\n  background-color: #000e4e;\n  width: 1440px;\n  height: 320px;\n  font-size: 16px;\n  color: #e7e9f2;\n}\n.registration-step-1 {\n  position: relative;\n  background-color: #fff;\n  width: 100%;\n  height: 2778px;\n  overflow: hidden;\n  text-align: left;\n  font-size: 18px;\n  color: #000e4e;\n}\n\nlabel.text-light-gray.form-label.form-label {\n  font-size: 12px;\n}\n\ninput.form-control.form-control-lg {\n  font-size: 16px;\n}\n\n.text-medium-22 {\n  color: var(--bs-dark-blue);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 160%;\n}\n\n.text-medium-18 {\n  color: var(--bs-dark-blue);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.text-regular-18 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 140%;\n}\n\n.text-medium-16 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 160%;\n}\n\n.text-semibold-16 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 140%;\n}\n\n.text-regular-16 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 160%;\n}\n\n.text-medium-14 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 160%;\n}\n\n.text-regular-14 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 160%;\n}\n\n.text-medium-12 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 160%;\n}\n\n.text-regular-12 {\n  color: var(--bs-gray-200);\n  font-family: 'Anek Bangla';\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 160%;\n}\n\n.container-fluid-1335 {\n  max-width: 1335px !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n@media (max-width: 576px) {\n  .item13 {\n    margin: auto 1rem auto 1rem;\n  }\n}\n.caret-off::before {\n  display: none;\n}\n.caret-off::after {\n  display: none;\n}\n\n.steps {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  position: relative;\n}\n.step-button {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  background-color: var(--prm-gray);\n  transition: 0.4s;\n}\n.step-button[aria-expanded='true'] {\n  width: 25px;\n  height: 25px;\n  font-size: 12px;\n}\n.done {\n  background-color: var(--prm-color);\n  color: #fff;\n}\n.step-item {\n  z-index: 10;\n  text-align: center;\n  margin-top: 1.5rem;\n}\n#progress {\n  -webkit-appearance: none;\n  position: absolute;\n  width: 100%;\n  z-index: 5;\n  border: #c8ccdf dashed;\n  border-width: 3px 0px 0px 0px;\n  top: 6.75rem;\n}\n\n#progress-complete {\n  -webkit-appearance: none;\n  position: absolute;\n  width: 100%;\n  z-index: 5;\n  border: rgb(var(--bs-primary-rgb)) solid;\n  border-width: 3px 0px 0px 0px;\n  top: 6.75rem;\n}\n/* to customize progress bar */\n\n#progress::-webkit-progress-value {\n  background-color: var(--prm-color);\n  transition: 0.5s ease;\n}\n#progress::-webkit-progress-bar {\n  background-color: var(--prm-gray);\n}\n.step-title {\n  width: 120px;\n  color: #7c84a5;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n.completed .step-title {\n  text-align: center;\n  font-weight: 500;\n  color: #000e4e;\n}\n.active .step-title {\n  font-weight: 500;\n  color: #0076ff;\n}\n.audit-heading {\n  color: var(--grayscaledark-blue);\n  font-family: var(--font-family-anek_bangla);\n  font-size: var(--font-size-xl);\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0;\n  white-space: nowrap;\n  line-height: 30.8px;\n}\n.supporting-text {\n  color: var(--grayscalelight-blue);\n  font-family: var(--font-family-anek_bangla);\n  font-size: var(--font-size-l);\n  letter-spacing: 0;\n  width: -moz-fit-content;\n  width: fit-content;\n  font-weight: 500;\n  line-height: 25.2px;\n}\n.report-audit .credit-box .x-account {\n  align-items: center;\n  background-color: var(--grayscalewhite);\n  border: 2px solid;\n  border-color: transparent;\n  border-image: linear-gradient(to bottom, rgb(60.56, 138.34, 255), rgb(72.25, 157.1, 255)) 1;\n  border-radius: 16px;\n  box-shadow: 0px 6px 40px #0076ff1a;\n  display: flex;\n  padding: 26px 30px;\n  margin: 2px auto;\n}\n.report-audit .credit-box .x-account .item-group .number {\n  color: var(--grayscaledark-blue);\n  font-family: var(--font-family-anek_bangla);\n  font-size: var(--font-size-xxl);\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0;\n  white-space: nowrap;\n  margin-top: -1px;\n  line-height: 36px;\n}\n.report-audit .credit-box .x-account .item-group .text {\n  color: var(--grayscalegray200);\n  font-family: var(--font-family-anek_bangla);\n  font-size: var(--font-size-m);\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0;\n  white-space: nowrap;\n  line-height: 25.6px;\n}\n.report-audit .credit-box .status {\n  height: 40px;\n  width: 40px;\n  background: linear-gradient(#4ebda9 0%, #ace7dc 100%);\n  border-radius: 100px;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  display: flex;\n  position: relative;\n  box-shadow: 0 4px 12px #4882ff1f;\n  top: -12px;\n}\n.report-audit .credit-box .status-1 {\n  background: linear-gradient(#fd7d7d 0%, #fda4a4 100%);\n}\n.report-audit .credit-box .status-2 {\n  background: linear-gradient(#f06bb3 0%, #f3add3 100%);\n}\n.report-audit .credit-box .status-3 {\n  background: linear-gradient(#7e69fe80 0%, #2300ff80 100%);\n}\n.report-audit .credit-box .status-4 {\n  background: linear-gradient(#0060ef80 0%, #0076ff80 100%);\n}\n\n.btn-light-blue {\n  --bs-btn-color: #fff;\n  background: linear-gradient(288.08deg, #ebf4ff 0%, #ebf4ff 100%);\n  --bs-btn-border-color: #b3d6ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0060ef;\n  --bs-btn-hover-border-color: #b3d6ff;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a58ca;\n  --bs-btn-active-border-color: #0a53be;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0076ff;\n  --bs-btn-disabled-border-color: #0076ff;\n}\n\n.bg-teal {\n  background-color: var(--bs-teal);\n}\n\n.bg-orange {\n  background-color: var(--bs-orange);\n}\n\n.bg-light-blue {\n  background: linear-gradient(288.08deg, #ebf4ff 0%, #ebf4ff 100%);\n}\n\n.bg-light-gray {\n  background: linear-gradient(288.08deg, var(--bs-gray-ultra-light) 0%, var(--bs-gray-ultra-light) 100%);\n}\n\n.bg-white {\n  background-color: white;\n}\n\n.bg-light-gray {\n  background-color: var(--bs-light-gray);\n}\n\n.border-light-gray {\n  --bs-border-opacity: 1;\n  border-color: var(--bs-light-gray) !important;\n}\n\n.border-dark-blue {\n  --bs-border-opacity: 1;\n  border-color: var(--bs-dark-blue) !important;\n}\n\n.border-card-cap {\n  --bs-border-opacity: 1;\n  border-color: var(--bs-card-cap-color) !important;\n}\n\n.bg-icon-violet {\n  background: linear-gradient(288.08deg, rgba(126, 105, 254, 0.5) 0%, rgba(35, 0, 255, 0.5) 100%);\n}\n\n.bg-icon-green {\n  background: linear-gradient(288.08deg, rgb(78, 189, 169) 0%, rgb(172, 231, 220) 100%);\n}\n\n.bg-icon-red {\n  background: linear-gradient(288.08deg, rgb(253, 125, 125) 0%, rgb(253, 164, 164) 100%);\n}\n\n.bg-icon-blue {\n  background: linear-gradient(288.08deg, #0076ff 0%, #248aff 100%);\n}\n/* utility class for w-x in increments of 5 */\n.w-5 {\n  width: 5% !important;\n}\n.w-10 {\n  width: 10% !important;\n}\n.w-15 {\n  width: 15% !important;\n}\n.w-20 {\n  width: 20% !important;\n}\n.w-25 {\n  width: 25% !important;\n}\n.w-30 {\n  width: 30% !important;\n}\n.w-35 {\n  width: 35% !important;\n}\n.w-40 {\n  width: 40% !important;\n}\n.w-45 {\n  width: 45% !important;\n}\n.w-50 {\n  width: 50% !important;\n}\n.w-55 {\n  width: 55% !important;\n}\n.w-60 {\n  width: 60% !important;\n}\n.w-65 {\n  width: 65% !important;\n}\n.w-70 {\n  width: 70% !important;\n}\n.w-75 {\n  width: 75% !important;\n}\n.w-80 {\n  width: 80% !important;\n}\n.w-85 {\n  width: 85% !important;\n}\n.w-90 {\n  width: 90% !important;\n}\n.w-95 {\n  width: 95% !important;\n}\n\n/* utility class for w-{size}-x in increments of 5 */\n@media (min-width: 576px) {\n  .w-sm-5 {\n    width: 5% !important;\n  }\n  .w-sm-10 {\n    width: 10% !important;\n  }\n  .w-sm-15 {\n    width: 15% !important;\n  }\n  .w-sm-20 {\n    width: 20% !important;\n  }\n  .w-sm-25 {\n    width: 25% !important;\n  }\n  .w-sm-30 {\n    width: 30% !important;\n  }\n  .w-sm-35 {\n    width: 35% !important;\n  }\n  .w-sm-40 {\n    width: 40% !important;\n  }\n  .w-sm-45 {\n    width: 45% !important;\n  }\n  .w-sm-50 {\n    width: 50% !important;\n  }\n  .w-sm-55 {\n    width: 55% !important;\n  }\n  .w-sm-60 {\n    width: 60% !important;\n  }\n  .w-sm-65 {\n    width: 65% !important;\n  }\n  .w-sm-70 {\n    width: 70% !important;\n  }\n  .w-sm-75 {\n    width: 75% !important;\n  }\n  .w-sm-80 {\n    width: 80% !important;\n  }\n  .w-sm-85 {\n    width: 85% !important;\n  }\n  .w-sm-90 {\n    width: 90% !important;\n  }\n  .w-sm-95 {\n    width: 95% !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .w-md-5 {\n    width: 5% !important;\n  }\n  .w-md-10 {\n    width: 10% !important;\n  }\n  .w-md-15 {\n    width: 15% !important;\n  }\n  .w-md-20 {\n    width: 20% !important;\n  }\n  .w-md-25 {\n    width: 25% !important;\n  }\n  .w-md-30 {\n    width: 30% !important;\n  }\n  .w-md-35 {\n    width: 35% !important;\n  }\n  .w-md-40 {\n    width: 40% !important;\n  }\n  .w-md-45 {\n    width: 45% !important;\n  }\n  .w-md-50 {\n    width: 50% !important;\n  }\n  .w-md-55 {\n    width: 55% !important;\n  }\n  .w-md-60 {\n    width: 60% !important;\n  }\n  .w-md-65 {\n    width: 65% !important;\n  }\n  .w-md-70 {\n    width: 70% !important;\n  }\n  .w-md-80 {\n    width: 80% !important;\n  }\n  .w-md-85 {\n    width: 85% !important;\n  }\n  .w-md-90 {\n    width: 90% !important;\n  }\n  .w-md-95 {\n    width: 95% !important;\n  }\n}\n\n/* Utility classes for large screens (min-width: 992px) */\n@media (min-width: 992px) {\n  .w-lg-5 {\n    width: 5% !important;\n  }\n  .w-lg-10 {\n    width: 10% !important;\n  }\n  .w-lg-15 {\n    width: 15% !important;\n  }\n  .w-lg-20 {\n    width: 20% !important;\n  }\n  .w-lg-30 {\n    width: 30% !important;\n  }\n  .w-lg-35 {\n    width: 35% !important;\n  }\n  .w-lg-40 {\n    width: 40% !important;\n  }\n  .w-lg-45 {\n    width: 45% !important;\n  }\n  .w-lg-50 {\n    width: 50% !important;\n  }\n  .w-lg-55 {\n    width: 55% !important;\n  }\n  .w-lg-60 {\n    width: 60% !important;\n  }\n  .w-lg-65 {\n    width: 65% !important;\n  }\n  .w-lg-70 {\n    width: 70% !important;\n  }\n  .w-lg-80 {\n    width: 80% !important;\n  }\n  .w-lg-85 {\n    width: 85% !important;\n  }\n  .w-lg-90 {\n    width: 90% !important;\n  }\n  .w-lg-95 {\n    width: 95% !important;\n  }\n}\n\n/* Utility classes for extra large screens (min-width: 1200px) */\n@media (min-width: 1200px) {\n  .w-xl-5 {\n    width: 5% !important;\n  }\n  .w-xl-10 {\n    width: 10% !important;\n  }\n  .w-xl-15 {\n    width: 15% !important;\n  }\n  .w-xl-20 {\n    width: 20% !important;\n  }\n  .w-xl-30 {\n    width: 30% !important;\n  }\n  .w-xl-35 {\n    width: 35% !important;\n  }\n  .w-xl-40 {\n    width: 40% !important;\n  }\n  .w-xl-45 {\n    width: 45% !important;\n  }\n  .w-xl-50 {\n    width: 50% !important;\n  }\n  .w-xl-55 {\n    width: 55% !important;\n  }\n  .w-xl-60 {\n    width: 60% !important;\n  }\n  .w-xl-65 {\n    width: 65% !important;\n  }\n  .w-xl-70 {\n    width: 70% !important;\n  }\n  .w-xl-80 {\n    width: 80% !important;\n  }\n  .w-xl-85 {\n    width: 85% !important;\n  }\n  .w-xl-90 {\n    width: 90% !important;\n  }\n  .w-xl-95 {\n    width: 95% !important;\n  }\n}\n\n/* Utility classes for large screens (min-width: 992px) */\n@media (min-width: 992px) {\n  .w-lg-5 {\n    width: 5% !important;\n  }\n  .w-lg-10 {\n    width: 10% !important;\n  }\n  .w-lg-15 {\n    width: 15% !important;\n  }\n  .w-lg-20 {\n    width: 20% !important;\n  }\n  .w-lg-30 {\n    width: 30% !important;\n  }\n  .w-lg-35 {\n    width: 35% !important;\n  }\n  .w-lg-40 {\n    width: 40% !important;\n  }\n  .w-lg-45 {\n    width: 45% !important;\n  }\n  .w-lg-50 {\n    width: 50% !important;\n  }\n  .w-lg-55 {\n    width: 55% !important;\n  }\n  .w-lg-60 {\n    width: 60% !important;\n  }\n  .w-lg-65 {\n    width: 65% !important;\n  }\n  .w-lg-70 {\n    width: 70% !important;\n  }\n  .w-lg-80 {\n    width: 80% !important;\n  }\n  .w-lg-85 {\n    width: 85% !important;\n  }\n  .w-lg-90 {\n    width: 90% !important;\n  }\n  .w-lg-95 {\n    width: 95% !important;\n  }\n}\n\n/* Utility classes for medium screens (min-width: 768px) */\n@media (min-width: 768px) {\n  .w-md-5 {\n    width: 5% !important;\n  }\n  .w-md-10 {\n    width: 10% !important;\n  }\n  .w-md-15 {\n    width: 15% !important;\n  }\n  .w-md-20 {\n    width: 20% !important;\n  }\n  .w-md-30 {\n    width: 30% !important;\n  }\n  .w-md-35 {\n    width: 35% !important;\n  }\n  .w-md-40 {\n    width: 40% !important;\n  }\n  .w-md-45 {\n    width: 45% !important;\n  }\n  .w-md-50 {\n    width: 50% !important;\n  }\n  .w-md-55 {\n    width: 55% !important;\n  }\n  .w-md-60 {\n    width: 60% !important;\n  }\n  .w-md-65 {\n    width: 65% !important;\n  }\n  .w-md-70 {\n    width: 70% !important;\n  }\n  .w-md-80 {\n    width: 80% !important;\n  }\n  .w-md-85 {\n    width: 85% !important;\n  }\n  .w-md-90 {\n    width: 90% !important;\n  }\n  .w-md-95 {\n    width: 95% !important;\n  }\n}\n/* Utility classes for small screens (min-width: 576px) */\n@media (min-width: 576px) {\n  .w-sm-5 {\n    width: 5% !important;\n  }\n  .w-sm-10 {\n    width: 10% !important;\n  }\n  .w-sm-15 {\n    width: 15% !important;\n  }\n  .w-sm-20 {\n    width: 20% !important;\n  }\n  .w-sm-30 {\n    width: 30% !important;\n  }\n  .w-sm-35 {\n    width: 35% !important;\n  }\n  .w-sm-40 {\n    width: 40% !important;\n  }\n  .w-sm-45 {\n    width: 45% !important;\n  }\n  .w-sm-50 {\n    width: 50% !important;\n  }\n  .w-sm-55 {\n    width: 55% !important;\n  }\n  .w-sm-60 {\n    width: 60% !important;\n  }\n  .w-sm-65 {\n    width: 65% !important;\n  }\n  .w-sm-70 {\n    width: 70% !important;\n  }\n  .w-sm-80 {\n    width: 80% !important;\n  }\n  .w-sm-85 {\n    width: 85% !important;\n  }\n  .w-sm-90 {\n    width: 90% !important;\n  }\n  .w-sm-95 {\n    width: 95% !important;\n  }\n}\n\n.shadow-more {\n  box-shadow: 0 6px 40px 0 rgb(var(--bs-primary-rgb), 0.5) !important;\n}\n\n.navbar {\n  border-bottom: 0;\n  box-shadow: none !important;\n}\n\n.navbar .nav-link {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 140%;\n  margin: auto 1rem;\n}\n\n/* Extra small devices (portrait phones, less than 576px) */\n/* No changes needed, default Bootstrap behavior is mobile-first */\n\n/* Small devices (landscape phones, 576px and up) */\n/* No changes needed, default Bootstrap behavior is mobile-first */\n\n/* Medium devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .position-static-md {\n    position: static !important;\n  }\n  .position-relative-md {\n    position: relative !important;\n  }\n  .position-absolute-md {\n    position: absolute !important;\n  }\n  .position-fixed-md {\n    position: fixed !important;\n  }\n  .position-sticky-md {\n    position: -webkit-sticky !important;\n    position: sticky !important;\n  }\n}\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .position-static-lg {\n    position: static !important;\n  }\n  .position-relative-lg {\n    position: relative !important;\n  }\n  .position-absolute-lg {\n    position: absolute !important;\n  }\n  .position-fixed-lg {\n    position: fixed !important;\n  }\n  .position-sticky-lg {\n    position: -webkit-sticky !important;\n    position: sticky !important;\n  }\n}\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  .position-static-xl {\n    position: static !important;\n  }\n  .position-relative-xl {\n    position: relative !important;\n  }\n  .position-absolute-xl {\n    position: absolute !important;\n  }\n  .position-fixed-xl {\n    position: fixed !important;\n  }\n  .position-sticky-xl {\n    position: -webkit-sticky !important;\n    position: sticky !important;\n  }\n}\n\n.visibility-hidden {\n  visibility: hidden !important;\n}\n\n.swal-confirm-button {\n  color: #fff !important;\n  background-color: #6c757d !important;\n  border-color: #6c757d !important;\n  padding: 0.25rem 2rem !important;\n  font-size: 1.25rem !important;\n  line-height: 1.5 !important;\n  border-radius: 0.3rem !important;\n  font-weight: 300 !important;\n}\n\n.swal-deny-button {\n  color: #fff !important;\n  background-color: var(--bs-danger) !important;\n  border-color: #6c757d !important;\n  padding: 0.25rem 2rem !important;\n  font-size: 1.25rem !important;\n  line-height: 1.5 !important;\n  border-radius: 0.3rem !important;\n  font-weight: 300 !important;\n}\n\n@media (max-width: 768px) {\n  .mobile-overflow-x-auto {\n    overflow-x: auto !important;\n    table-layout: auto !important;\n  }\n\n  .mobile-overflow-x-auto thead,\n  .mobile-overflow-x-auto td {\n    white-space: nowrap !important;\n  }\n}\n\n.infoButton.popover {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.infoButton.popover .popover-header {\n  background-color: #fff;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.infoButton.popover .popover-body {\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: justify;\n}\n\n/* REPORT AUDIT SWITCH */\n\n.switch {\n  position: relative;\n  display: block;\n  vertical-align: top;\n  width: 120px;\n  height: 30px;\n  padding: 3px;\n  margin: auto auto auto 0;\n  background: linear-gradient(to bottom, #eeeeee, #ffffff 25px);\n  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff 25px);\n  border-radius: 18px;\n  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  box-sizing: content-box;\n}\n.switch-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  box-sizing: content-box;\n}\n.switch-label {\n  position: relative;\n  display: block;\n  height: inherit;\n  font-size: 10px;\n  text-transform: uppercase;\n  background: #eceeef;\n  border-radius: inherit;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12), inset 0 0 2px rgba(0, 0, 0, 0.15);\n  box-sizing: content-box;\n}\n.switch-label:before,\n.switch-label:after {\n  position: absolute;\n  top: 50%;\n  margin-top: -0.5em;\n  line-height: 1;\n  -webkit-transition: inherit;\n  -moz-transition: inherit;\n  -o-transition: inherit;\n  transition: inherit;\n  box-sizing: content-box;\n}\n.switch-label:before {\n  content: attr(data-off);\n  right: 11px;\n  font-weight: 500;\n  color: var(--bs-dark-blue);\n  text-shadow: 0 1px rgba(255, 255, 255, 0.5);\n}\n.switch-label:after {\n  content: attr(data-on);\n  left: 11px;\n  color: #ffffff;\n  text-shadow: 0 1px rgba(0, 0, 0, 0.2);\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label {\n  background: linear-gradient(90deg, #ff2b2b 0%, #f66 100%);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2);\n}\n.switch-input:checked ~ .switch-label:before {\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label:after {\n  opacity: 1;\n}\n.switch-handle {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(to bottom, #ffffff 40%, #f0f0f0);\n  background-image: -webkit-linear-gradient(top, #ffffff 40%, #f0f0f0);\n  border-radius: 100%;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n.switch-handle:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -6px 0 0 -6px;\n  width: 12px;\n  height: 12px;\n  background: linear-gradient(to bottom, #eeeeee, #ffffff);\n  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff);\n  border-radius: 6px;\n  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);\n}\n.switch-input:checked ~ .switch-handle {\n  left: 94px;\n  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n\n/* Transition\n========================== */\n.switch-label,\n.switch-handle {\n  transition: All 0.3s ease;\n  -webkit-transition: All 0.3s ease;\n  -moz-transition: All 0.3s ease;\n  -o-transition: All 0.3s ease;\n}\n\n#launcher-frame {\n  bottom: 63px;\n}\n.react-joyride__tooltip button {\n  background-color: #0076ff !important; /* Change this to your desired color */\n  border-color: #0076ff !important; /* Change this to your desired color */\n}\n\n/* Change the button hover background color */\n.react-joyride__tooltip button:hover {\n  background-color: #1b1848 !important; /* Change this to your desired hover color */\n  border-color: #0076ff !important; /* Change this to your desired hover color */\n}\n\n/* Change the button properties */\n.react-joyride__tooltip button[type='button'][data-action='back'] {\n  appearance: none !important;\n  background-color: transparent !important;\n  border-style: none !important;\n  color: #0076ff !important;\n  cursor: pointer !important;\n  font-family: 'Anek Bangla', sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  line-height: 16px !important;\n  margin: 0 !important;\n  margin-right: auto !important;\n  padding: 8px !important;\n  text-align: center !important;\n  text-transform: none !important;\n  visibility: visible !important;\n}\n.react-joyride__tooltip button[type='button'][data-action='skip'] {\n  appearance: none !important;\n  background-color: transparent !important;\n  border-style: none !important;\n  color: #0076ff !important;\n  cursor: pointer !important;\n  font-family: 'Anek Bangla', sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  line-height: 16px !important;\n  margin: 0 !important;\n  margin-right: auto !important;\n  padding: 8px !important;\n  text-align: center !important;\n  text-transform: none !important;\n  visibility: visible !important;\n}\n\n.main {\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n}\n\n.content {\n  max-width: 100% !important;\n}\n\n.sonar-wrapper {\n  position: absolute;\n  top: 25px;\n  right: 55px;\n}\n\n.sonar-effect {\n  top: -2px;\n  left: -2px;\n  bottom: 0;\n  z-index: 0;\n  border-radius: 50%;\n  opacity: 0;\n  animation: sonar-animation 2s linear infinite;\n  background: #dc3545;\n  padding: 1.2rem;\n}\n.sonar-effect-green{\nbackground: #41a995 !important;\n}\n\n.number-sonar {\n\ttop: -3px;\n\tleft: -3px;\n\tbottom: 0;\n\tz-index: 0;\n\tborder-radius: 50%;\n\topacity: 0;\n\tanimation: sonar-animation 2s linear infinite;\n\n\tpadding: 1.2rem;\n}\n\n@keyframes sonar-animation {\n  0% {\n    transform: scale(0.1);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1);\n    opacity: .8;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n.btn-sonar-effect{\n  transition: all .3s;\n  -webkit-transition: all .3s;\n  -moz-transition: all .3s;\n  animation: sonar-btn 1s ease-in-out infinite;\n}\n\n.btn-sonar-effect:after {\n  pointer-events: none;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50px;\n  content: '';\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.btn-sonar-effect:after {\n  top: 0;\n  left: 0;\n  padding: 0;\n  z-index: 0;\n  box-shadow: 0 0 0 2px rgba(252, 0, 0, 0.1);\n  opacity: 0;\n  -webkit-transform: scale(0.7);\n  -moz-transform: scale(0.7);\n  -ms-transform: scale(0.7);\n  transform: scale(0.7);\n  -webkit-animation: sonarEffect .5s ease-out infinite;\n  -moz-animation: sonarEffect .5s ease-out infinite;\n  animation: sonarEffect .5s ease-out infinite;\n}\n\n@keyframes sonarEffect {\n  0% {\n    opacity: 0.3;\n}\n\n40% {\n    opacity: 0.7;\n    box-shadow: 0 0 0 2px rgba(231, 9, 9, 0.1), 0 0 1px 2px #4e3f41;\n}\n\n100% {\n    box-shadow: 0 0 0 2px rgba(255, 94, 94, 0.1), 0 0 1px 2px rgba(37, 37, 37, 0.5);\n    -webkit-transform: scale(1.03);\n    opacity: 0;\n}\n}\n\n@keyframes sonar-btn {\n  0% {\n    transform: scale(1);\n  }\n\n  40% {\n    transform: scale(0.95);\n  }\n  60%{\n    transform: scale(0.98);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
